import React, { createContext, useContext } from "react";
import { gql, useQuery } from "@apollo/client";

const USER_LIST_QUERY = gql`
  query userList($user_list_request: user_list_request) {
    user(user_list_request: $user_list_request) {
      edges {
        id
        username
        display_name
        app_role {
          name
        }
      }
    }
  }
`;

function normalizeListUser(u) {
  if (!u) return u;
  return {
    ...u,
    _id: u.id != null ? String(u.id) : u._id,
    name: u.name ?? u.username ?? u.display_name,
    role: u.app_role?.name ?? u.role ?? null,
  };
}

const UserListContext = createContext([]);
export const useUserList = () => useContext(UserListContext);

export function UserListProvider({ children }) {
  const { data, error } = useQuery(USER_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      user_list_request: {
        filters: [{ field: "enabled_active", operator: "=", value: "true" }],
        pagination: { limit: 10000 },
        sorting: [{ field: "username", direction: "ASC" }],
      },
    },
  });

  if (error) {
    console.error("Failed to fetch user list:", error);
  }

  const userList = (data?.user?.edges ?? []).map(normalizeListUser);

  return (
    <UserListContext.Provider value={userList}>
      {children}
    </UserListContext.Provider>
  );
}
